const randomArrayPicker = <T>(array: T[]): T => {
  if (!array.length) console.warn('Empty array passed to randomArrayPicker(). This will return undefined.');
  return array[Math.floor(Math.random() * array.length)];
};

export default randomArrayPicker;
